import type { ReactNode } from "react";

interface ScheduledBriefingsTabPageHeaderProps {
  title: string;
  description: ReactNode;
  actions?: ReactNode;
}

export const ScheduledBriefingsTabPageHeader = ({
  title,
  description,
  actions,
}: ScheduledBriefingsTabPageHeaderProps) => (
  <header className="shrink-0 bg-white px-16 pt-6 pb-6">
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex flex-col gap-2">
        <h1 className="text-xl font-medium text-gray-900">{title}</h1>
        <p className="max-w-xl text-sm tracking-[0.14px] text-gray-700">
          {description}
        </p>
      </div>
      {actions ?? null}
    </div>
  </header>
);
